<template>
  <div>
    <v-card>
      <v-card-title>
        Edit Wholesaler
        <v-spacer></v-spacer>
        <v-btn icon
          ><v-icon color="dark" @click="close">mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-divider class="mx-4 mb-2"></v-divider>
      <v-card-title class="pb-5">
        Account Number: {{ model.accountNumber }}
      </v-card-title>
      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <ValidationProvider name="Name">
                <v-text-field
                  label="Name"
                  dense
                  outlined
                  clearable
                  v-model="model.name"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="4">
              <ValidationProvider name="Company">
                <v-text-field
                  label="Company"
                  dense
                  outlined
                  clearable
                  v-model="model.company"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="4">
              <ValidationProvider name="Contact Email">
                <v-text-field
                  label="Contact Email"
                  dense
                  outlined
                  clearable
                  v-model="model.contactEmail"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <ValidationProvider name="Cancel Date">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="pt-0 mt-0"
                      v-model="model.cancelDate"
                      label="Cancel Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="model.cancelDate"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
            <v-col cols="6">
              <ValidationProvider name="Default Billing ID">
                <v-text-field
                  label="Default Billing ID"
                  dense
                  outlined
                  clearable
                  v-model="model.defaultBillingId"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <ValidationProvider name="SP Code">
                <v-text-field
                  label="SP Code"
                  dense
                  outlined
                  clearable
                  v-model="model.sp_code"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="3">
              <ValidationProvider name="Radius User">
                <v-select
                  dense
                  outlined
                  v-model="model.is_radius_user"
                  :items="selectRadiusUser"
                  label="Radius User"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="2">
              <ValidationProvider name="Visp User">
                <v-select
                  dense
                  outlined
                  v-model="model.vispUser"
                  :items="selectVispUser"
                  label="Visp User"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="2">
              <ValidationProvider name="Active">
                <v-select
                  dense
                  outlined
                  v-model="model.isActive"
                  :items="selectIsActive"
                  label="Active"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="2">
              <ValidationProvider name="Contract Term">
                <v-select
                  dense
                  outlined
                  v-model="model.useContractTerm"
                  :items="selectUseContractTerm"
                  label="Contract Term"
                  item-text="text"
                  item-value="value"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <ValidationProvider
                name="Customer Number"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="selectedCustomerNumber"
                  label="UB Account Number"
                  outlined
                  dense
                  clearable
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="5">
              <ValidationProvider
                name="Radius Account ID"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="selectedRadiusAccountID"
                  :items="radiusAccountsList"
                  item-text="name"
                  item-value="radiusId"
                  hide-selected
                  label="Radius Account Id"
                  outlined
                  dense
                  clearable
                  :error-messages="errors"
                ></v-autocomplete>
              </ValidationProvider>
            </v-col>
            <v-col cols="4">
              <ValidationProvider name="Features">
                <v-select
                  dense
                  outlined
                  v-model="model.features"
                  multiple
                  label="Features"
                  :items="features"
                  item-text="description"
                  item-value="id"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <ValidationProvider
                name="One Login Email"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="model.oneLoginEmail"
                  label="One Login Email"
                  outlined
                  dense
                  clearable
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-row>
            <v-col cols="12" class="my-3 py-0 px-0">
              <v-divider class="mx-3"></v-divider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pt-5">
              <h3>Associated Logins:</h3>
            </v-col>
            <v-col cols="6" class="d-flex justify-end mb-0">
              <v-btn color="primary" @click="createEvent">Add Login</v-btn>
            </v-col>
          </v-row>
          <WholesalerLogins
            v-if="!isLoadingLogins"
            :accountNumber="model.accountNumber"
            :wholesalerLogins="wholesalerLogins"
            :page="page"
            :refresh="refresh"
            @update:refresh="refresh = false"
            @selectRow="updateEvent"
            @delete="triggerDelete"
          ></WholesalerLogins>

          <v-row>
            <v-col cols="12" class="text-center">
              <v-pagination
                v-model="page.number"
                :length="page.totalPages"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
              ></v-pagination>
            </v-col>
          </v-row>

          <v-dialog v-model="dialog.active" width="500" persistent>
            <UpsertWholesalerLogin
              @close="dialog.active = false"
              @save="createLogins"
              :action="`create`"
              :header="dialog.header"
              v-if="dialog.target == 'create'"
            ></UpsertWholesalerLogin>
            <UpsertWholesalerLogin
              @close="dialog.active = false"
              @update="updateLogin"
              :action="`update`"
              :modelValue="selectedRow"
              :header="dialog.header"
              v-if="dialog.target == 'update'"
            ></UpsertWholesalerLogin>
          </v-dialog>
          <confirm
            :dialog="confirmDialog"
            :text="
              `You are about to delete this login. Do you want to proceed?`
            "
            :proceedText="`Yes, delete`"
            :cancelText="`Cancel`"
            @onBtnClick="deleteLogin"
          ></confirm>
        </v-card-text>

        <v-card-text>
          <v-row>
            <v-col cols="12" class="my-3 py-0 px-0">
              <v-divider class="mx-3"></v-divider>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn
                @click.prevent="save"
                color="dark"
                class="white--text mr-4"
                :disabled="!dirty || invalid"
                >Save</v-btn
              >
              <v-btn @click="close">Close</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </ValidationObserver>
    </v-card>
  </div>
</template>
<script>
import WholesalerLogins from "@/components/WholesalerLogins.vue";
import UpsertWholesalerLogin from "@/components/UpsertWholesalerLogin.vue";
import confirm from "@/components/confirm.vue";

export default {
  name: "edit-wholesaler",
  components: { WholesalerLogins, UpsertWholesalerLogin, confirm },
  data: () => ({
    features: [],
    wholesalerFeatures: [],
    menu: false,
    model: {},
    selectRadiusUser: [
      { text: "Yes", value: "y" },
      { text: "No", value: "n" }
    ],
    selectVispUser: [
      { text: "True", value: true },
      { text: "False", value: false }
    ],
    selectIsActive: [
      { text: "True", value: true },
      { text: "False", value: false }
    ],
    selectUseContractTerm: [
      { text: "Yes", value: true },
      { text: "No", value: false }
    ],
    layerOptions: [{ text: "Layer 3", value: 3 }],
    customerNumber: null,
    searchCustomerNumber: null,
    radiusAccountID: null,
    searchRadiusAccountID: null,
    fields: [5000, 6000, 7000],
    tempCustomersList: [],
    radiusAccountsList: [],
    selectedCustomerNumber: null,
    selectedRadiusAccountID: null,
    loginDialog: false,
    refresh: false,
    dialog: {
      target: "",
      header: "",
      active: false
    },
    selectedRow: {},
    wholesalerLogins: [],
    page: {
      number: 1,
      size: 5,
      keyword: "",
      totalPages: 1
    },
    confirmDialog: false,
    isLoadingLogins: false
    // layer: null
  }),
  props: {
    wholesalerForEdit: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  beforeMount() {
    Object.assign(this.model, this.wholesalerForEdit);
  },
  mounted() {
    let vm = this;

    vm.getFeatures();
    vm.getWholesalerLogins();

    vm.$store
      .dispatch("service/getRadiusAccounts")
      .then(data => {
        vm.radiusAccountsList = data;
      })
      .catch(e => {
        console.log(e);
      });
    if (vm.model) {
      vm.selectedCustomerNumber = vm.model.ubCustomerNumber;
      vm.selectedRadiusAccountID = vm.model.radiusAccountId;
    }
  },
  methods: {
    getFeatures() {
      let vm = this;
      vm.$store
        .dispatch("service/getFeatures")
        .then(data => {
          vm.features = data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    save() {
      let vm = this;
      vm.model.ubCustomerNumber = vm.selectedCustomerNumber;
      vm.model.radiusAccountId = parseInt(vm.selectedRadiusAccountID);
      vm.setWholesalersForUpdate(vm.model);
      this.$emit("save", vm.features);
      this.close();
    },
    close() {
      this.$refs.observer.reset();
      this.model = {};
      this.$emit("close");
    },

    async createLogins(logins) {
      const vm = this;
      const payload = {
        emails: logins,
        accountNumber: vm.model.accountNumber
      };
      await vm.createWholesalerLogin(payload).then(async () => {
        vm.dialog = {
          target: "",
          header: "",
          active: false
        };
        vm.getWholesalerLogins();
      });
    },

    async getWholesalerLogins() {
      const vm = this;

      vm.isLoadingLogins = true;

      const payload = {
        pageNo: vm.page.number,
        pageSize: vm.page.size,
        keyword: vm.page.keyword,
        accountNumber: vm.model.accountNumber
      };
      await vm.readWholesalerLogins(payload).then(data => {
        vm.wholesalerLogins = data.data.items;
        vm.page.totalPages = data.data.totalPages;
        vm.$emit("update:refresh");
      }).finally(() => {
        vm.isLoadingLogins = false;
      });
    },

    async updateLogin() {
      const vm = this;

      const payload = {
        id: vm.selectedRow.id,
        email: vm.selectedRow.email,
        accountNumber: vm.model.accountNumber
      };
      await vm.updateWholesalerLogin(payload).then(() => {
        vm.dialog = {
          target: "",
          header: "",
          active: false
        };
      });
    },

    async deleteLogin(confirm) {
      const vm = this;

      if (confirm) {
        const payload = {
          id: vm.selectedRow.id,
          accountNumber: vm.model.accountNumber
        };

        await vm.deleteWholesalerLogin(payload).then(() => {
          vm.getWholesalerLogins();
          vm.confirmDialog = false;
        });
      } else {
        vm.selectedRow = {};
        vm.confirmDialog = false;
      }
    },

    createEvent() {
      const vm = this;
      vm.dialog = {
        active: true,
        header: "Add New Logins",
        target: "create"
      };
    },
    updateEvent(row) {
      const vm = this;
      vm.selectedRow = row;
      vm.dialog = {
        active: true,
        header: "Update Login",
        target: "update"
      };
    },
    triggerDelete(data) {
      const vm = this;
      vm.selectedRow = data;
      vm.confirmDialog = true;
    }
  },
  watch: {
    "page.number": {
      deep: true,
      handler() {
        const vm = this;
        vm.getWholesalerLogins();
      }
    }
  }
};
</script>
